"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _Interval = _interopRequireDefault(require("../../models/interval/Interval"));

var _ascendingComparator = _interopRequireDefault(require("./ascendingComparator"));

var _isEmpty = _interopRequireDefault(require("./isEmpty"));

var _isFunction = _interopRequireDefault(require("../object/isFunction"));

var createRangeInterval = function createRangeInterval(start, end) {
  return new _Interval["default"](start, end);
};

var groupContinuousValues = function groupContinuousValues(array) {
  var createIntervalCallback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : createRangeInterval;
  if ((0, _isEmpty["default"])(array)) return [];
  if (!(0, _isFunction["default"])(createIntervalCallback)) return []; // use Set to remove duplicates

  var removedDuplicate = new Set(array);
  var sorted = (0, _toConsumableArray2["default"])(removedDuplicate).sort(_ascendingComparator["default"]);
  var _final = [];
  var currentValue = sorted[0];

  _final.push(createIntervalCallback(currentValue, currentValue));

  for (var i = 1; i < sorted.length; i++) {
    var nextValue = sorted[i];

    if (nextValue === currentValue + 1) {
      currentValue = nextValue;
      continue;
    } // update the end of the previous interval


    var _currentInterval = _final[_final.length - 1];
    _final[_final.length - 1] = createIntervalCallback(_currentInterval.start, currentValue);

    _final.push(createIntervalCallback(nextValue, nextValue));

    currentValue = nextValue;
  } // handle last index


  var currentInterval = _final[_final.length - 1];
  _final[_final.length - 1] = createIntervalCallback(currentInterval.start, currentValue);
  return _final;
};

var _default = groupContinuousValues;
exports["default"] = _default;